<template>
    <div class="page-view" :style="styleObj">
        <video style="display: none" id="video" webkit-playsinline playsinline loop>
            <source :src="publicPath + 'caption.mp4'">
        </video>

        <div style="text-align: center" id="three">

        </div>

        <div class="shopopee-chat-view" :class="shopopeeChatStatus === 'hide' ? 'shopopee-chat-view-retract' : 'shopopee-chat-view-extend'" v-show="shopopeeChatVisible === true">
            <div style="position: relative; width: 100%; height: 100%;">
                <phoneDemo
                    ref="shopopeePhone"
                    @exec-command-complete="phoneCommandCallback"
                    @login-complete="loginCallback"
                    @goShopPosition="goShopPosition"
                    @goThreeGuide="goThreeGuide"
                    @clickAudio="clickAudio"
                    @returnShopopee="clickReturnShopopee"
                    :class="shopopeeChatStatus === 'hide' ? 'hide-phone' : 'show-phone'"
                />

                <div
                    class="close-div"
                    :class="shopopeeChatStatus === 'hide' ? 'close-div-hide' : 'close-div-show'"
                    @click="hideShopopeeChatBox">
                    <font-awesome-icon icon="fa-solid fa-xmark" />
                </div>
            </div>
        </div>

        <FloorSelector
            v-show="selectFloorVisible === true"
            :currPage="regionMap.currPage"
            :lastPageNum="lastPageNum"
            @clickClose="closeSelectFloor"
            @clickFloor="goSelectFloor"
            @clickReturn="clickReturn3DCityBtn"
        />

        <!--    加载页面    -->
        <LoadingWithCar
            v-if="loadingCarViewVisible === true"
            :usePercent="usePercent"
            :useCarImg="false"
            :percent="loadingPercent"
        />

        <UpperRightInteractionUI
            @goLogin="goLogin"
            @goAccount="goAccountView"
            @goChat="goChatView"
            v-show="upperRightUiVisible === true"
        />

        <UpperSearchInput
            v-show="upperRightUiVisible === true"
            @clickInput="clickSearchInput"
        />

        <UpperLeftInteractionUI
            v-show="upperRightUiVisible === true"
            @goSelectLang="langSelectVisible = true"
            @goSelectReturn="clickReturnIcon"
        />

        <!--    下方的操作栏    -->
        <BottomInteraction
            :bottomUIObj="bottomUIObj"
            @clickIcon="clickInteractionCallback"
            v-show="bottomInteractionUiVisible === true"
        />

        <div ref="operationNipple" v-show="nippleViewVisible" style="display: inline-block; width: 50px; height: 50px; position: absolute; left: 10%; bottom: 165px; opacity: 0">

        </div>

        <languageSelect
            v-if="langSelectVisible == true"
            :confirmFlag="true"
            @save-complete="langSelectVisible = false"
        />

        <!--    询问框    -->
        <ConfirmComponent
            v-show="confirmVisible === true"
            :confirmText="confirmText"
            @clickSure="sureConfirm"
            @clickCancel="closeConfirm"
        />

        <el-dialog
            v-model="materialViewVisible"
            :title="i18n.tkey('lang_details')"
            :width="materialDialogWidth"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="closeDialogCallback"
        >
            <div class="my-dialog">
                <MaterialDetail
                    :obj="currMaterial"
                    @clickChat="clickMaterialChatCallback"
                />
            </div>
        </el-dialog>

        <el-dialog
            v-model="searchPEMaterialVisible"
            :title="i18n.tkey('lang_search_text')"
            :width="isMobile ? '90%' : '800px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close=""
        >
            <SearchPEMaterialComponent/>
        </el-dialog>
    </div>
</template>

<script setup>

import {
    getCurrentInstance,
    onBeforeUnmount,
    onMounted,
    onBeforeMount,
    ref,
    toRef,
    provide,
    inject,
    watch,
    computed,
    reactive
} from 'vue'
import nipplejs from "nipplejs"
import { useUserinfo } from '@/stores/userinfo'
import { usePageinfo } from "@/stores/pageinfo";
import myUtil from "@/util/util";
import {GLTFLoader} from "three/addons/loaders/GLTFLoader";
import {FBXLoader} from "three/addons/loaders/FBXLoader";
import {DRACOLoader} from "three/addons/loaders/DRACOLoader";
import { KTX2Loader } from "three/addons/loaders/KTX2Loader";
import {MeshoptDecoder} from "three/addons/libs/meshopt_decoder.module";
import * as TWEEN from "@tweenjs/tween.js";
import {clone} from "three/addons/utils/SkeletonUtils";
import materialApi from "@/request/materialApi";
import MaterialDetail from "@/components/shopopee/material/materialDetail.vue";
import UpperRightInteractionUI from "@/components/Shopopee3D/ui/upperRightInteractionUI.vue";
import phoneDemo from '@/views/phoneDemo.vue'
import ConfirmComponent from "@/plugins/projectA/ui/confirmComponent.vue";
import LoadingWithCar from "@/plugins/projectA/ui/loadingWithCar.vue";
import UpperLeftInteractionUI from "@/components/Shopopee3D/ui/upperLeftInteractionUI.vue";
import UpperSearchInput from "@/components/Shopopee3D/ui/upperSearchInput.vue";
import FloorSelector from "@/components/Shopopee3D/ui/floorSelector.vue";
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCommentDots, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faElevator, faRectangleList, faLanguage, faFileInvoiceDollar, faLeftRight } from '@fortawesome/free-solid-svg-icons'
import LanguageSelect from "@/components/Shopopee3D/ui/languageSelect.vue";
import SearchPEMaterialComponent from "@/components/phone/searchPEMaterialComponent.vue";
import companyApi from "@/request/companyApi";
import {GUI} from "dat.gui";
import BottomInteraction from "@/plugins/projectA/ui/bottomInteraction.vue";

library.add(faCommentDots, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faElevator, faRectangleList, faLanguage, faFileInvoiceDollar, faLeftRight)

const props = defineProps(["rid"])

let { proxy } = getCurrentInstance();
let THREE = proxy.$THREE;

const publicPath = process.env.BASE_URL

const userInfoRef = toRef(useUserinfo())
const pageInfoRef = toRef(usePageinfo())

const shopCompanyCode = ref(null)

//是否顯示語言選擇框
const langSelectVisible = ref(false)
//是否显示市场选择框
const hallSelectorVisible = ref(false)
//需要全屏查看的圖片
const previewImgUrl = ref(null)
//全屏查看圖片的title
const previewImgTitle = ref(null)
//全屏查看圖片button的text
const previewBtnText = ref(null)
//全屏查看的圖片展位號
let previewImgDoor = null

const i18n = inject("i18n")
const isMobile = myUtil.isMobile()
const pageWidth = window.innerWidth
const pageHeight = window.innerHeight
const styleObj = ref({})

//纹理贴图加载器TextureLoader
const texLoader = new THREE.TextureLoader();
const gltfLoader = new GLTFLoader();
const fbxLoader = new FBXLoader();
const dracoLoader = new DRACOLoader();
const ktx2loader = new KTX2Loader()

//所有動作
let allActions ;

//每次渲染要執行的邏輯方法列表
let funcListObj = {}
//重新加载时需要删除的模型
let clearMeshList = []
//重新加载时需要删除的数据
let clearDataList = []
//要關閉AI的對象
let clearAIList = []

//加载百分比
let loadingPercent = ref(0)
//是否顯示百分比
const usePercent = ref(true)

let animationFrameId

// 3D场景对象Scene
let scene
//渲染器
let render
//摄像机
let camera
//天空盒攝像機
let cubeCamera

const clock = new THREE.Clock();
const FPS = 30; // 指的是 30帧每秒的情况
const singleFrameTime = (1/FPS);
let timeStamp = 0
// let currTimeStamp = 0
let mixerUpdateDelta;

let mousedownFlag = false
let touchPoint = null
//是否按下搖桿
let nippleFlag = false
//是否开始渲染
let renderFlag = true

//是否可操作
let controlFlag = false
//操作模式
let operateMode = "normal"

//搖桿對象
let nippleObj = null

//可交互对象列表
let interactionList = []
//可交互對象映射對象
const interactionObj = {}

//拥有ai的对象
const WithAIObjSet = {}

//动作列表
const mixerObj = {}

// let MAX_POSITION_X = 13.8
// let MIN_POSITION_X = -7.5
// let MAX_POSITION_Z = 44.8
// let MIN_POSITION_Z = -44.8

let MAX_POSITION_X = 13.8
let MIN_POSITION_X = -9.5
let MAX_POSITION_Z = 58.8
let MIN_POSITION_Z = -44.8

//是否在移動
let moveFlag = false
//移動方向
const moveVector3 = new THREE.Vector3()
moveVector3.normalize()
//方向增量
const numVector3 = new THREE.Vector3()
//操作列表
const operationObj = {
    "w": false,
    "d": false,
    "s": false,
    "a": false,
}

//Y轴向量
const yAxis = new THREE.Vector3(0,1,0)

//模型朝向
const faceVector3 = new THREE.Vector3()

//移动速度上限 (秒)
let MAXSPEED = process.env.NODE_ENV === 'production' ? userInfoRef.value.speed : userInfoRef.value.speed;
//当前移动速度
let speed = 0
//移動速度增量 (秒)
const speedAddSize = 0.6
//移動速度減量 (秒)
const speedMinusSize = 1.2
//移动射线
// const moveRaycaster = new THREE.Raycaster()
//移動計時
let moveTimeStamp = 0
//鼠标按下计时
let mouseDownTimeStamp = 0

//全局环境贴图
let sceneEnvironmentMap
let testEnvMap

//rotation角度
let rotationNum = Math.PI / -2
//rotation角度 上下
let rotationNumY = 0

const width = window.innerWidth
const height = window.innerHeight

//环境光
let ambient = new THREE.AmbientLight(0xffffff, 1.5);

//是否显示下方的操作栏
const bottomInteractionUiVisible = ref(false)
//是否顯示右上角的操作欄
const upperRightUiVisible = ref(false)
//是否顯示搖桿
const nippleViewVisible = ref(true)
//下方的互动选项
const bottomUIObj = ref({})

//动画对象
const animationObjGroup = {}

//人对象组
const meshGroup = new THREE.Group()
const headGroup = new THREE.Group()

//觸發區域對象
const triggerAreaMap = {}

//當前執行的動作
let activeAction;
//上一個執行的動作
let previousAction;

//岛列表
const islandList = []
//店铺Group map
let shopPointMap = {}
//楼层和门牌号映射的map
const regionMap = reactive({
    currPage: 1,
    lastPage: 1,
    selectShopIndex: null,
    shopMap: {},
})

let testBox

//加载过的物件
const loadObj = {}
//是否正在加载fbx模型
let fbxLoadFlag = false
//fbx模型的加载队列
const fbxLoadQueue = []
//是否正在加载glb模型
let glbLoadFlag = false
//glb模型的加载队列
const glbLoadQueue = []

//主角模型
let model

//空氣墻列表
const airWallList = {

}

//是否显示聊天窗口
let shopopeeChatVisible = ref(false)
let shopopeeChatStatus = ref("hide")

//直升機加載切換頁
const loadingCarViewVisible = ref(true)

//展館信息
let hallObjInfo = {}
//產品列表
const materialList = ref([])
//产品位置map
const materialMap = ref({})
//圖片位置列表
const materialPositionMap = {}
//图片名字位置列表
const materialNameMap = {}
//图片加载队列
const imgLoadQueue = {}

//要查看的產品
const currMaterial = ref(null)
const materialViewVisible = ref(false)

const searchPEMaterialVisible = ref(false)

//提示文字
let confirmText = ref("")
//是否提示可见
let confirmVisible = ref(false)
//確定按鈕綁定的方法
let confirmFunc
//取消按鈕綁定的方法
let cancelFunc

let hallFloorPadMesh = null

//是否顯示選擇區域頁面
const selectFloorVisible = ref(false)
//最後一個區的區號
const lastPageNum = ref(1)
//選擇的區號
const selectFloorNum = ref(1)

const materialDialogWidth = computed(() => {
    if (myUtil.isMobile()){
        if (window.innerWidth > 768){
            return "640px"
        }else{
            return '90%'
        }
    }else{
        return "640px"
    }
})

const cameraOptionObj = {
    //默认的第一人稱镜头距离
    defaultFirstCameraDistance: 0.1,
    //默认的第三人稱镜头距离
    defaultThirdCameraDistance: 3,
    //默认的镜头距离
    defaultCameraDistance: 0.1,
    //当前的镜头距离
    currCameraDistance: 0.1,
    //是否改变了镜头距离
    changeCameraDistance: false,
    //默认的镜头高度
    defalutCameraPositionY: 1.6,
    //当前的镜头高度
    currCameraPositionY: 1.6,
    //是否改变了镜头高度
    changeCameraPostionY: false,
    //默認鏡頭視點高度
    defaultLookAtPosition: 1.6,
    //默認鏡頭視點高度
    currLookAtPosition: 1.6,
}

function initValue() {
    dracoLoader.setDecoderPath(`${process.env.BASE_URL}static/js/draco/`)
    dracoLoader.setDecoderConfig({ type: 'js' });
    dracoLoader.preload();
    gltfLoader.setDRACOLoader(dracoLoader)
    gltfLoader.setKTX2Loader(ktx2loader)
    gltfLoader.setMeshoptDecoder(MeshoptDecoder)


    funcListObj['updateAIObj'] = updateAIObj
    funcListObj['checkTriggerMap'] = checkTriggerMap
    funcListObj['checkInteractionObj'] = checkInteractionObj

    scene = new THREE.Scene()
    // camera = new THREE.PerspectiveCamera(45, 8.0 / 5.0, 0.1, 600)
    const fov = isMobile ? 60 : 45

    THREE.ColorManagement.enabled = true;

    camera = new THREE.PerspectiveCamera(fov, 8.0 / 3.0, 0.11, 700)
    camera.aspect = (window.innerWidth) / (window.innerHeight);
    camera.updateProjectionMatrix();
    render = new THREE.WebGLRenderer({
        // logarithmicDepthBuffer: true, // 设置对数深度缓冲区，优化深度冲突问题
        antialias: true, //开启抗锯齿,
        alpha: true,
        precision: 'mediump',
        powerPreference: "high-performance",
    })

    render.gammaInput = true;
    render.gammaOutput = true;//inear转gamma
    render.toneMapping = THREE.ACESFilmicToneMapping
    render.outputColorSpace = THREE.SRGBColorSpace
    render.useLegacyLights = true

    render.setPixelRatio(window.devicePixelRatio); //设置屏幕像素比
    // render.setPixelRatio(1); //设置屏幕像素比
    render.setClearColor(0x000000, 1); //设置背景色

    initPage()
}

function initPage() {
    cameraOptionObj.defaultLookAtPosition = 1.6
    cameraOptionObj.currLookAtPosition = 1.6
    cameraOptionObj.defalutCameraPositionY = 1.6
    cameraOptionObj.currCameraPositionY = 1.6

    if (isMobile){
        document.getElementById("three").addEventListener('touchmove', handleDefaultTouchEvt, {passive: false})
    }

    //創建搖桿
    var options = {
        zone: proxy.$refs.operationNipple,
        mode: 'static',
        position: {left: '50%', top: '50%'},
        // color: 'gray',
        color: 'red',
        size: window.innerWidth > 768 ? 100 : 80,
        threshold: 0.1
    }

    const manager = nipplejs.create(options);
    nippleObj = manager

    nippleObj.on('start', function (evt, data) {
        if (!controlFlag){
            return;
        }

        nippleFlag = true

    });

    nippleObj.on('move', function (evt, data) {

        if (!controlFlag){
            return;
        }

        if (operateMode === "watch"){

            funcListObj["moveCameraFunc_1"] = () => {
                rotationNum += data.vector.x * 0.02 * 30 * mixerUpdateDelta
                rotationNumY += data.vector.y * 0.005 * 30 * mixerUpdateDelta

                calcCameraPosition()
            }

        }else{
            if ((data.angle.radian > Math.PI / 180 * 45 && data.angle.radian < Math.PI / 180 * 135) || (data.angle.radian > Math.PI / 180 * 225 && data.angle.radian < Math.PI / 180 * 315)){

                if (null != funcListObj["moveCameraFunc_1"]){
                    delete funcListObj["moveCameraFunc_1"]
                }

                mousedownFlag = true
                moveFlag = true

                moveVector3.x = 0 - camera.position.x
                moveVector3.y = 0
                moveVector3.z = 0 - camera.position.z

                moveVector3.normalize()
                moveVector3.applyAxisAngle(yAxis, data.angle.radian - Math.PI / 2)

            }else{
                mousedownFlag = false
                moveFlag = false

                if (data.angle.radian > Math.PI / 180 * 135 && data.angle.radian < Math.PI / 180 * 225){
                    funcListObj["moveCameraFunc_1"] = () => {
                        rotationNum -= data.distance / 50 * 0.02 * 30 * mixerUpdateDelta

                        calcCameraPosition()
                    }
                }else{
                    funcListObj["moveCameraFunc_1"] = () => {
                        rotationNum += data.distance / 50 * 0.02 * 30 * mixerUpdateDelta

                        calcCameraPosition()
                    }
                }
            }
        }

    });

    nippleObj.on('end', function (evt, data) {
        // console.log(data)

        mousedownFlag = false
        moveFlag = false
        touchPoint = null
        nippleFlag = false

        delete funcListObj["moveCameraFunc_1"]
    });

    proxy.$refs.operationNipple.style.opacity = 0
    // proxy.$refs.operationNipple.style.display = "none"

    //創建島
    createIsland()
    //創建空氣墻
    createHallAirWall()

    //加入对象组
    scene.add(meshGroup)

    //造人
    createMan()

    meshGroup.add(camera)
    camera.position.set(0,5,-16);
    camera.lookAt(new THREE.Vector3(0,5,0));

    //添加环境光
    scene.add(ambient);

    //加載天空盒
    const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256 );
    cubeCamera = new THREE.CubeCamera( 0.1, 1000, cubeRenderTarget)

    let environmentMap = new THREE.CubeTextureLoader().load( [
        process.env.BASE_URL + "mytextures/skt/px.jpg",
        process.env.BASE_URL + "mytextures/skt/nx.jpg",
        process.env.BASE_URL + "mytextures/skt/py.jpg",
        process.env.BASE_URL + "mytextures/skt/ny.jpg",
        process.env.BASE_URL + "mytextures/skt/pz.jpg",
        process.env.BASE_URL + "mytextures/skt/nz.jpg"], function (cubeTexture) {

        sceneEnvironmentMap = environmentMap
        scene.background = cubeTexture;

        cubeCamera.update( render, scene );

    } );

    let environmentMap2 = new THREE.CubeTextureLoader().load( [
        process.env.BASE_URL + "mytextures/sky2/posx.jpg",
        process.env.BASE_URL + "mytextures/sky2/negx.jpg",
        process.env.BASE_URL + "mytextures/sky2/posy.jpg",
        process.env.BASE_URL + "mytextures/sky2/negy.jpg",
        process.env.BASE_URL + "mytextures/sky2/posz.jpg",
        process.env.BASE_URL + "mytextures/sky2/negz.jpg"], function (cubeTexture) {

        testEnvMap = cubeTexture

    } );


    render.setSize(width, height);
    render.shadowMap.enabled = true //渲染器開啟陰影渲染
    render.shadowMap.type = THREE.PCFSoftShadowMap;
    render.render(scene, camera);

    document.getElementById("three").innerHTML = ""
    document.getElementById("three").appendChild(render.domElement);

    //监听鼠标、键盘事件
    document.addEventListener( 'keydown', onKeyDown );
    document.addEventListener( 'keyup', onKeyUp );

    if (isMobile){
        document.getElementById("three").addEventListener("touchmove", mouseMoveEvent)

        document.getElementById("three").addEventListener("touchstart", mouseDownEvent)

        document.getElementById("three").addEventListener("touchend", mouseUpEvent)

    }else{
        document.getElementById("three").addEventListener("mousemove", mouseMoveEvent)

        document.getElementById("three").addEventListener("mousedown", mouseDownEvent)

        document.getElementById("three").addEventListener("mouseup", mouseUpEvent)

        document.getElementById("three").addEventListener("click", mouseClickEvent)
    }
}

//触摸事件处理
function handleDefaultTouchEvt(evt) {
    if(!materialViewVisible.value && !searchPEMaterialVisible.value && !hallSelectorVisible.value){
        evt.preventDefault()
    }
}

function updateAIObj() {
    for( let i in WithAIObjSet){
        if (typeof WithAIObjSet[i].AI === "function"){
            WithAIObjSet[i].AI(WithAIObjSet[i])
        }
    }
}

function checkInteractionObj() {
    for (let key in interactionObj){
        const objList = interactionObj[key]

        objList.forEach((obj, i) => {
            if (null != obj.mesh && null != obj.name){
                if (null != obj.distance){
                    const objuuid = obj.mesh.uuid + i
                    const vec3 = new THREE.Vector3()
                    obj.mesh.getWorldPosition(vec3)
                    const distance = meshGroup.position.distanceTo(vec3)

                    if (distance <= obj.distance && !(objuuid in bottomUIObj.value)){
                        if (null !== obj.trigger){
                            obj.trigger = true

                            if (null != obj.triggerCallback && typeof obj.triggerCallback === "function"){
                                obj.triggerCallback()
                            }
                        }

                        if (null == obj.UIFlag || true === obj.UIFlag){
                            let flag = true

                            if (null != obj.displayFlag){
                                if (typeof obj.displayFlag === "function"){
                                    flag = obj.displayFlag()
                                }else{
                                    flag = obj.displayFlag
                                }
                            }

                            if (flag){
                                bottomUIObj.value[objuuid] = {
                                    icon: obj.icon,
                                    text: obj.name,
                                    description: obj.description,
                                    callback: () => {
                                        obj.callback()
                                    }
                                }
                            }

                        }

                    }

                    if(distance > obj.distance && (objuuid in bottomUIObj.value)){
                        if (objuuid in bottomUIObj.value){
                            delete bottomUIObj.value[objuuid]
                        }

                        if (null !== obj.trigger && true === obj.trigger){
                            obj.trigger = false

                            if (null != obj.leaveCallback && typeof obj.leaveCallback === "function"){
                                obj.leaveCallback()
                            }
                        }
                    }
                }

            }
        })

    }
}

//檢測觸發區域
function checkTriggerMap() {
    for (const key in triggerAreaMap){
        const obj = triggerAreaMap[key]

        if (checkInAreaFlag(obj.scope)){
            if (!obj.alive && (obj.timer > obj.timeLimit)){
                obj.timer = 0
                obj.alive = true

                if (typeof obj.func === "function"){
                    obj.func()
                }
            }
        }else{
            if (!obj.alive){
                obj.timer += mixerUpdateDelta
            }else{
                obj.alive = false

                if (null != obj.leaveCallback && typeof obj.leaveCallback === "function"){
                    obj.leaveCallback()
                }
            }
        }
    }
}

//檢測主角是否在某個區域中
function checkInAreaFlag(obj){
    const flagX1 = meshGroup.position.x < obj.MAX_POSITION_X
    const flagX2 = meshGroup.position.x > obj.MIN_POSITION_X

    const flagZ1 = meshGroup.position.z < obj.MAX_POSITION_Z
    const flagZ2 = meshGroup.position.z > obj.MIN_POSITION_Z

    return flagX1 && flagX2 && flagZ1 && flagZ2
}

function calcCameraPosition() {
    if (operateMode === "watch" || !isMobile){
        if (rotationNumY > 0.25){
            rotationNumY = 0.25
        }

        if (rotationNumY < -0.25){
            rotationNumY = -0.25
        }

        let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
        let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

        camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
        // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
        camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currLookAtPosition + rotationNumY,meshGroup.position.z));
    }else{
        let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
        let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

        camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
        // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
        camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currLookAtPosition,meshGroup.position.z));
    }
}

function mouseDownEvent(e){
    if (!controlFlag){
        return;
    }

    mouseDownTimeStamp = e.timeStamp

    if (!isMobile){
        mousedownFlag = true
    }

    // moveFlag = true
    //
    if (isMobile){
        if (null == e.touches){
            return
        }

        touchPoint = e.touches[0]
    }

    // var obj = getMousePosition(e)

    // obj.direction.setY(0)
    // moveVector3.copy(obj.direction)
}

function mouseUpEvent(e){
    if (isMobile){
        if (controlFlag){
            const temp = {
                touches: [
                    touchPoint
                ]
            }
            mouseClickEvent(temp)
        }
    }

    mousedownFlag = false
    moveFlag = false
    touchPoint = null
}

function mouseMoveEvent(e){
    if (!mousedownFlag)
        return

    if (!controlFlag){
        return;
    }

    if (isMobile && operateMode != "watch"){
        return;
    }

    // if (nippleFlag){
    //     return;
    // }

    if (isMobile){
        if (null == e.changedTouches){
            return
        }

        rotationNum -= (touchPoint.clientX - e.changedTouches[0].clientX) / 300;
        touchPoint = e.changedTouches[0]
    }else{
        rotationNum += e.movementX / 300;
        rotationNumY -= e.movementY / 1200;
    }

    //如果改变了镜头距离
    if (cameraOptionObj.changeCameraDistance){
        cameraOptionObj.changeCameraDistance = false

        const tween = new TWEEN.Tween(cameraOptionObj)
            .to({currCameraDistance: cameraOptionObj.defaultCameraDistance}, 5000)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.InOut)
            .onComplete(() => {
                delete animationObjGroup["changeCameraDistance"]
            })
            .onUpdate(() => {
                let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
                let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

                camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
                // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
                camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currLookAtPosition,meshGroup.position.z));
            })

        animationObjGroup["changeCameraDistance"] = tween
    }

    //如果改变了镜头高度
    if (cameraOptionObj.changeCameraPostionY){
        cameraOptionObj.changeCameraPostionY = false

        const tween = new TWEEN.Tween(cameraOptionObj)
            .to({currCameraPositionY: cameraOptionObj.defalutCameraPositionY}, 5000)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.InOut)
            .onComplete(() => {

                delete animationObjGroup["changeCameraPostionY"]
            })
            .onUpdate(() => {
                camera.position.y = cameraOptionObj.currCameraPositionY
            })

        animationObjGroup["changeCameraPostionY"] = tween
    }

    calcCameraPosition()

}

function mouseClickEvent(e){
    if (!controlFlag){
        return;
    }

    if (null != previewImgUrl.value){
        return;
    }

    if (e.timeStamp - mouseDownTimeStamp > 1000){
        return;
    }

    const obj = getMousePosition(e, interactionList)

    if (null == obj){
        return;
    }

    if (obj.intersects != null && obj.intersects.length > 0){
        const intersect = obj.intersects[0]
        if (intersect.distance < 30){
            const uuid = intersect.object.uuid
            const temp = interactionObj[uuid]

            if (temp.length > 0){
                for (const item in temp){
                    const obj = temp[item]
                    if (obj != null && null != obj.callback && typeof obj.callback === "function"){
                        obj.callback()
                    }
                }
            }else{
                if (temp != null && null != temp.callback && typeof temp.callback === "function"){
                    temp.callback()
                }
            }
        }
    }
}

function onKeyDown( event ) {
    if (!controlFlag){
        return;
    }

    if (null != event && (event.code != 'KeyW' && event.code != 'KeyS' && event.code != 'KeyA' && event.code != 'KeyD' && event.code != 'ArrowUp' && event.code != 'ArrowDown' && event.code != 'ArrowLeft' && event.code != 'ArrowRight' )){
        return
    }

    if ( null != event || (operationObj.w || operationObj.s || operationObj.a || operationObj.d) ){
        camera.getWorldDirection(numVector3)
    }

    numVector3.setY(0)

    if (null != event ){
        switch ( event.code ) {

            case 'ArrowUp':
            case 'KeyW':
                if (!operationObj.w){
                    operationObj.w = true
                }

                moveFlag = true

                break;

            case 'ArrowDown':
            case 'KeyS':
                if (!operationObj.s){
                    operationObj.s = true
                }

                moveFlag = true

                break;

            // case 'ArrowLeft':
            case 'KeyA':
                if (!operationObj.a){
                    operationObj.a = true
                }

                moveFlag = true

                break;

            // case 'ArrowRight':
            case 'KeyD':
                if (!operationObj.d){
                    operationObj.d = true
                }

                moveFlag = true

                break;

            case 'ArrowLeft':
                funcListObj["moveCameraFunc_1"] = () => {
                    rotationNum -=  0.02 * 30 * mixerUpdateDelta

                    calcCameraPosition()
                }
                break;

            case 'ArrowRight':
                funcListObj["moveCameraFunc_1"] = () => {
                    rotationNum +=  0.02 * 30 * mixerUpdateDelta

                    calcCameraPosition()
                }
                break;

            // case 'KeyC': controls.crouch = true; break;
            // case 'Space': controls.jump = true; break;
            // case 'ControlLeft':
            // case 'ControlRight': controls.attack = true; break;

        }
    }



    if (operationObj.w){
        // 不需要改變方向
    }

    if (operationObj.s){
        numVector3.negate()
    }

    if (operationObj.a){
        if (operationObj.w){
            numVector3.applyAxisAngle(yAxis,Math.PI/4)
        }else if(operationObj.s){
            numVector3.applyAxisAngle(yAxis,Math.PI/4 * -1)
        }else{
            numVector3.applyAxisAngle(yAxis,Math.PI/2)
        }

    }

    if (operationObj.d){

        if (operationObj.w){
            numVector3.applyAxisAngle(yAxis,Math.PI/4 * -1)
        }else if(operationObj.s){
            numVector3.applyAxisAngle(yAxis,Math.PI/4)
        }else{
            numVector3.applyAxisAngle(yAxis,Math.PI/2 * -1)
        }

    }

    moveVector3.copy(numVector3)

    // moveFlag = true

}

//按键抬起
function onKeyUp( event ) {

    switch ( event.code ) {

        case 'ArrowUp':
        case 'KeyW':
            if (operationObj.w){
                operationObj.w = false
                onKeyDown()
            }
            break;

        case 'ArrowDown':
        case 'KeyS':
            if (operationObj.s){
                operationObj.s = false
                onKeyDown()
            }
            break;

        // case 'ArrowLeft':
        case 'KeyA':
            if (operationObj.a){
                operationObj.a = false
                onKeyDown()
            }
            break;

        // case 'ArrowRight':
        case 'KeyD':
            if (operationObj.d){
                operationObj.d = false
                onKeyDown()
            }
            break;

        case 'ArrowLeft':
            delete funcListObj["moveCameraFunc_1"]
            break;

        case 'ArrowRight':
            delete funcListObj["moveCameraFunc_1"]
            break;
    }

    if ( !(operationObj.w || operationObj.s || operationObj.a || operationObj.d) ){
        moveFlag = false
        numVector3.set(0, 0, 0)
    }

}

function getMousePosition(e, objList = islandList){
    const obj = {
        position: null,
        direction: null,
        intersects: []
    }

    let px
    let py

    if (isMobile){
        try {
            px = e.touches[0].clientX - 10;
            py = e.touches[0].clientY - 10;
        }catch (e) {
            return
        }
    }else{
        px = e.clientX - 10;
        py = e.clientY - 10;
    }

    //屏幕坐标px、py转标准设备坐标x、y
    //width、height表示canvas画布宽高度
    const x = (px / width) * 2 - 1;
    const y = -(py / height) * 2 + 1;

    //创建一个射线投射器`Raycaster`
    const raycaster = new THREE.Raycaster();

    raycaster.setFromCamera(new THREE.Vector2(x, y), camera);

    // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
    const intersects = raycaster.intersectObjects(objList);

    if (intersects != null && intersects.length > 0){
        obj.intersects = intersects
        obj.position = intersects[0].point
    }

    if (obj.intersects.length > 0){
        const point = obj.intersects[0].point
        const vec3 = new THREE.Vector3()

        vec3.x = point.x - meshGroup.position.x
        vec3.z = point.z - meshGroup.position.z

        vec3.normalize()
        obj.direction = vec3
    }else{
        obj.direction = raycaster.ray.direction
    }



    return obj
}

//切換動作
function toggleActiveMotion(name){
    activeAction.paused = true
    previousAction = activeAction
    activeAction = allActions[name];
    activeAction.reset().play();

    previousAction.crossFadeTo( activeAction, 0.25 )
}

function createIsland(){
    loadGlbModel("island/pav/albedo/PersonalExhibition.gltf", {
        loadCallback: (gltf, model) => {
            model.traverse( function ( object ) {
                if(object.name == "top_light") {
                    // 1.创建透明度贴图-纹理对象
                    const filename = `${publicPath}mymodels/gltf/island/pav/albedo/black_Ceiling_Open_Cell_001_opacity.jpg`
                    const alphaTexture = texLoader.load(filename);

                    alphaTexture.wrapS = alphaTexture.wrapT = THREE.RepeatWrapping;
                    alphaTexture.colorSpace = THREE.SRGBColorSpace
                    alphaTexture.repeat.set(6, 9)

                    object.material.transparent = true
                    object.material.alphaMap = alphaTexture
                }

                if(object.name == "qiang_glass2"){
                    const material = new THREE.MeshPhysicalMaterial({
                        color: 0xffffff,
                        metalness:0.25,
                        roughness:0,
                        emissive:0x333333,
                        transmission:1.0,
                    });
                    object.material = material
                }

                if (object.name.indexOf("Billboard_") != -1){
                    // object.rotation.y = Math.PI
                    materialPositionMap[object.name.replace("Billboard_", "")] = object
                }

                if (object.name.indexOf("shop_") != -1){
                    shopPointMap[object.name.replaceAll("shop_", "")] = {
                        positionObj: object,
                        shopmanPositionObj: null,
                        shopObj: null,
                        shopman: null
                    }
                }

                //創建展館樓層標識
                if (object.name == 'aiqiang_num'){
                    hallFloorPadMesh = object
                    createFloorNamePad()
                }


                if (object.name == 'exhibitionbox'){
                    object.visible = false
                }


                if (object.name == 'exhibitionimg'){
                    // object.visible = false
                    //加载视频
                    let video = document.getElementById("video");
                    const shopopeeAdsPlaneTex = new THREE.VideoTexture(video);
                    shopopeeAdsPlaneTex.center.set(0.6, 0.5)
                    shopopeeAdsPlaneTex.flipY  = false
                    // shopopeeAdsPlaneTex.rotation =  -Math.PI /2
                    const shopopeeAdsMaterial = new THREE.MeshBasicMaterial({ //普通材质
                        // color: 0xffffff,//0xff0000设置材质颜色为红色
                        map: shopopeeAdsPlaneTex,
                        // side: THREE.DoubleSide
                    });
                    object.material = shopopeeAdsMaterial
                    object.rotation.y = Math.PI
                }

                if (object.name == 'aiqiang_title'){
                    object.visible = false

                    // let boxGeometry = new THREE.BoxGeometry(6, 6, 1)
                    // let lambertMaterial = new THREE.MeshBasicMaterial({
                    //     color: 0xff0000
                    // })
                    //
                    // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
                    // scene.add(mesh)
                    // mesh.position.x = 0
                    // mesh.position.z = 0
                    //
                    // const gui = new GUI()
                    // gui.add(mesh.position, "x").step(0.1)
                    // gui.add(mesh.position, "z").step(0.1)
                }

                if (object.name == 'door' || object.name == 'elevator'){
                    const vec3 = new THREE.Vector3()
                    object.getWorldPosition(vec3)

                    triggerAreaMap[object.uuid] = {
                        scope: {
                            MAX_POSITION_X: vec3.x + 3,
                            MIN_POSITION_X: vec3.x - 3,
                            MAX_POSITION_Z: vec3.z + 1,
                            MIN_POSITION_Z: vec3.z - 1 ,
                        },
                        alive: false,
                        timer: 0.5,
                        timeLimit: 0.5,
                        func: () => {
                            meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                            toggleSelectFloorBox(true)
                        }
                    }
                }

                if (object.name === "shopman_01"){
                    createHost(object)
                }

                if (object.name === "lectern"){

                    const vec3 = new THREE.Vector3()
                    object.getWorldPosition(vec3)

                    airWallList[object.uuid] = {
                        MAX_POSITION_X: vec3.x + 2,
                        MIN_POSITION_X: vec3.x - 2,
                        MAX_POSITION_Z: vec3.z + 2,
                        MIN_POSITION_Z: vec3.z - 2
                    }
                }

                // if(object.name.indexOf("Billboardborber") != -1){
                //     object.visible = false
                // }

                if (object.name.indexOf("BillboardName_") != -1){
                    materialNameMap[object.name.replaceAll("BillboardName_", "")] = object
                }
            })

            loadMaterialImg()
            loadingPercent.value += 5
        },
        callback: (group) => {

            scene.add(group)
            islandList.push(group)

            var video = document.getElementById("video");
            video.volume = 0
            video.muted = true
            try{
                video.play()
            }catch(e){
                console.log(e)
            }
        }
    })
}

function createMan() {
    let fileName = process.env.BASE_URL + "mymodels/fbx/town2/woman.fbx"

    loadLeadModel(fileName, true)

    //临时放置
    meshGroup.visible = false
    cameraOptionObj.defaultCameraDistance = cameraOptionObj.defaultFirstCameraDistance
    cameraOptionObj.currCameraDistance = cameraOptionObj.defaultFirstCameraDistance
    camera.far = 400
    camera.updateProjectionMatrix()

    // toggleActiveMotion("idle")
    // rotationNum = camera.rotation.y
    rotationNum = 4.69

    const positionX = 0
    const positionY = cameraOptionObj.defalutCameraPositionY
    const positionZ = - cameraOptionObj.defaultCameraDistance

    const rotationX = 0 - Math.PI
    const rotationY = 0
    const rotationZ = Math.PI

    camera.position.x = positionX
    camera.position.y = positionY
    camera.position.z = positionZ

    camera.rotation.x = rotationX
    camera.rotation.y = rotationY
    camera.rotation.z = rotationZ

    controlFlag = true
    nippleViewVisible.value = true
    proxy.$refs.operationNipple.style.display = "block"

    renderFrame()
}

function loadLeadModel(fileName, initFlag = false) {
    fbxLoader.load(fileName, (fbx) => {

        model = fbx;
        testBox = model
        //放大縮小
        let box3 = new THREE.Box3()
        let obj = new THREE.Vector3()
        let scaleNum
        box3.setFromObject(model)
        box3.getSize(obj)

        scaleNum = 2.6 / obj.getComponent(1)

        let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
        model.scale.multiply(vector);

        box3.setFromObject(model)
        box3.getSize(obj)

        model.position.x = 0
        model.position.y = 0
        model.position.z = 0

        meshGroup.add( model );

        model.traverse( function ( object ) {

            if ( object.isMesh ) {
                object.castShadow = true;

                object.material.emissive = new THREE.Color(1,1,1);
                object.material.emissiveIntensity = 1;
                object.material.emissiveMap = object.material.map;
            }

            if (object.name === "ashangshen"){
                object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            }

            if (object.name === "asjiao"){
                object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
                // const material = new THREE.MeshLambertMaterial()
                // material.copy(object.material)
                // object.material = material
                // object.material.color = new THREE.Color(0, 0, 1)
                // object.material.shininess = 0
            }

            if (object.name === "astui"){
                object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            }

            if (object.name === "toufa"){
                const material = new THREE.MeshLambertMaterial()
                material.copy(object.material)
                object.material = material
            }
        } );

        //动作
        const mixer = new THREE.AnimationMixer( model );
        mixerObj[meshGroup.id] = mixer
        //注册动作播放方法
        funcListObj['updateMixerByTime'] = updateMixerByTime

        allActions = {};

        let animations = fbx.animations;

        //遍歷所有動作
        for ( let i = 0; i !== animations.length; ++ i ) {
            //動作
            const clip = animations[ i ];
            const action = mixer.clipAction( clip );
            allActions[clip.name ] = action;

        }

        activeAction = allActions['idle'];
        activeAction.play();

        //将头加入到人物
        meshGroup.add(headGroup)
        headGroup.position.setY(2.5)

        //將燈光綁定到人物
        // meshGroup.add(directionalLight)
        // const lightPoint = new THREE.Group()
        // meshGroup.add(lightPoint)
        // lightPoint.position.set(50, 0, 50)
        // directionalLight.position.set(0, 50, 0)
        // directionalLight.target = lightPoint

        //注册改变太阳光焦点方法
        // funcListObj['changeSunLightTarget'] = () => {
        //     directionalLight.target = lightPoint
        // }

        loadingPercent.value += 5
        renderFlag = true

        if (initFlag){
            // loadingPercent.value += 10
            loadLeadModelCallback()
        }

    })
}

function loadLeadModelCallback() {
    //注册人物移动方法
    funcListObj['movePerson'] = movePerson

    meshGroup.position.set(0, 0, -40.5)
    calcCameraPosition()

    proxy.$refs.operationNipple.style.display = "block"

    controlFlag = true

    renderFrame()
}

function renderFrame() {
    // stats.update();
    mixerUpdateDelta = clock.getDelta()

    if (loadingPercent.value > 9 &&loadingPercent.value < 100){
        loadingPercent.value += 1
    }
    else if (loadingPercent.value == 100){
        usePercent.value = false
        loadingPercent.value += 1

        // loadGlbModel("island/disanzhanting79.glb", {
        //     callback: (group) => {
        //         scene.add(group)
        //     }
        // })

        setTimeout(() => {
            loadingCarViewVisible.value = false
            proxy.$refs.operationNipple.style.opacity = 1
            bottomInteractionUiVisible.value = true
            upperRightUiVisible.value = true

            if (null != regionMap.selectShopIndex){
                goNextRegion()
                // movePersonToShopPosition(regionMap.selectShopIndex)
                regionMap.selectShopIndex = null
            }

            // if (null == props.fid){
                toggleSelectFloorBox(true)
            // }

            saveShopVisits()
        }, 250)

    }



    //更新时间戳
    if (renderFlag){
        for (const v in funcListObj){
            if (typeof funcListObj[v] === "function"){
                funcListObj[v]()
            }
        }
    }

    // getSceneModelFaceNum(scene)
    timeStamp += mixerUpdateDelta;
    if (timeStamp > singleFrameTime) {
        render.render(scene, camera)

        //渲染
        // 剩余的时间合并进入下次的判断计算 这里使用取余数是因为 当页页面失去焦点又重新获得焦点的时候，delta数值会非常大， 这个时候就需要
        timeStamp = (timeStamp % singleFrameTime);
    }

    animationFrameId = requestAnimationFrame(renderFrame)

}

//更新播放动作方法
function updateMixerByTime(){
    //播放动画
    for (let i in mixerObj){
        mixerObj[i].update( mixerUpdateDelta );
    }
}

//人物移动方法
function movePerson(){
    if (moveFlag || speed > 0){
        const currAddSize = mixerUpdateDelta * speedAddSize
        const currMinusSize = mixerUpdateDelta * speedMinusSize
        moveVector3.normalize()

        if (moveFlag){
            speed += currAddSize

            if (speed >= userInfoRef.value.speed){
                speed = userInfoRef.value.speed
            }
        }else{
            speed *= 0.96
            speed -= currMinusSize

            if (speed < 0.06){
                speed = 0
                moveVector3.set(0, 0, 0)
                toggleActiveMotion("idle")
            }
        }

        let timeScale = speed / 0.06
        const currMoveSpeed = speed * 60 * mixerUpdateDelta

        if (speed > 0.12){
            timeScale = 1
            timeScale += (speed - 0.12) / 14.0

            if (activeAction._clip.name == "walk"){
                toggleActiveMotion("running")
            }
        }else if (speed > 0 && speed <= 1.2){
            timeScale = 1

            if (activeAction._clip.name == "running"){
                toggleActiveMotion("walk")
            }else if (activeAction._clip.name == "idle"){
                toggleActiveMotion("walk")
            }
        }

        activeAction.timeScale = timeScale

        meshGroup.translateOnAxis(moveVector3, currMoveSpeed);

        let xnum2 = meshGroup.position.x + 1 * moveVector3.getComponent(0)
        let znum2 = meshGroup.position.z + 1 * moveVector3.getComponent(2)

        testBox.getWorldDirection(faceVector3)

        if (speed > 0){
            testBox.lookAt(xnum2, meshGroup.position.y, znum2)
        }

        for (const key in airWallList){
            const v = airWallList[key]
            const flagX1 = meshGroup.position.x < v.MAX_POSITION_X
            const flagX2 = meshGroup.position.x > v.MIN_POSITION_X

            const flagZ1 = meshGroup.position.z < v.MAX_POSITION_Z
            const flagZ2 = meshGroup.position.z > v.MIN_POSITION_Z
            // console.log(key)
            // console.log("flagX1: " + flagX1+ ",flagX2:" + flagX2+ ",flagZ1:" + flagZ1+ ",flagZ2:" + flagZ2)
            if (flagX1 && flagX2 && flagZ1 && flagZ2){

                // if (Math.abs(v.MAX_POSITION_X - meshGroup.position.x) < Math.abs(v.MIN_POSITION_X - meshGroup.position.x)){
                //     meshGroup.position.x = v.MAX_POSITION_X + 0.2
                // }else{
                //     meshGroup.position.x = v.MIN_POSITION_X - 0.2
                // }

                let minX = null
                let minZ = null
                let min = null

                const distanceX1 = Math.abs(v.MAX_POSITION_X - meshGroup.position.x)
                const distanceX2 = Math.abs(v.MIN_POSITION_X - meshGroup.position.x)

                const distanceZ1 = Math.abs(v.MAX_POSITION_Z - meshGroup.position.z)
                const distanceZ2 = Math.abs(v.MIN_POSITION_Z - meshGroup.position.z)

                minX = distanceX1 < distanceX2 ? distanceX1 : distanceX2
                minZ = distanceZ1 < distanceZ2 ? distanceZ1 : distanceZ2
                min = minX < minZ ? minX : minZ
                min = min * -1 - 0.2
                meshGroup.translateOnAxis(moveVector3, min);
                // if (Math.abs(v.MAX_POSITION_Z - meshGroup.position.z) < Math.abs(v.MIN_POSITION_Z - meshGroup.position.z)){
                //     meshGroup.position.z = v.MAX_POSITION_Z + 0.2
                // }else{
                //     meshGroup.position.z = v.MIN_POSITION_Z - 0.2
                // }
            }
        }

        if (meshGroup.position.x > MAX_POSITION_X){
            meshGroup.position.x = MAX_POSITION_X - 0.2
        }

        if (meshGroup.position.x < MIN_POSITION_X){
            meshGroup.position.x = MIN_POSITION_X + 0.2
        }

        if (meshGroup.position.z > MAX_POSITION_Z){
            meshGroup.position.z = MAX_POSITION_Z - 0.2
        }

        if (meshGroup.position.z < MIN_POSITION_Z){
            meshGroup.position.z = MIN_POSITION_Z + 0.2
        }

        moveTimeStamp += mixerUpdateDelta

        if (moveTimeStamp > 1.0){
            moveTimeStamp = moveTimeStamp % 1.0
        }

        // console.log("x: " + meshGroup.position.x + " ,z: " + meshGroup.position.z)
    }
}

//記錄訪問量
async function saveShopVisits() {

    // const request = record12Api.insertHallViewRecord
    // const params = request.getParams()
    //
    // params.companycode = null
    // params.login = userInfoRef.value.login
    // params.addinfo1 = userInfoRef.value.hid
    // params.addinfo2 = userInfoRef.value.id
    // params.addinfo3 = userInfoRef.value.country
    //
    // request.send(params, () => {})

}

function goNextRegion(){
//显示过渡页面
    loadingCarViewVisible.value = true
    //關閉下方的操作欄
    bottomInteractionUiVisible.value = false
    //關閉右上角的操作欄
    upperRightUiVisible.value = false
    //隱藏搖桿
    nippleViewVisible.value = false
    //关闭手机
    shopopeeChatVisible.value = false
    //是否使用店铺传送点
    let transferTag = null != regionMap.selectShopIndex
    //不允许操作
    controlFlag = false
    //清除当前区域信息
    clearSenceData()
    //清除下方操作栏内容
    // clearBottomUI()

    //清除区牌材质
    createFloorNamePad()

    userInfoRef.value.fid = regionMap.currPage

    //将人物移动到初始坐标
    if (null != regionMap.selectShopIndex){
        movePersonToShopPosition(regionMap.selectShopIndex)
        regionMap.selectShopIndex = null
    }else{
        meshGroup.position.x = 0
        meshGroup.position.z = -40
    }

    toggleActiveMotion("idle")

    //刪除店鋪數據
    for (const key in regionMap.shopMap){
        const obj = regionMap.shopMap[key]
        obj.shopObj = null
        obj.shopman = null
    }

    for (const key in shopPointMap){
        const obj = shopPointMap[key]
        obj.shopObj = null
        obj.shopman = null
    }

    const notDelList = []

    interactionList.forEach((v, i) => {
        if (false == v.__deleteTag__){
            notDelList.push(v)
        }
    })

    interactionList = notDelList

    setTimeout(() => {
        //加载下一区的数据
        loadMaterialImg()

    }, 1000)

    setTimeout(() => {
        nippleViewVisible.value = false
    }, 251)

    setTimeout(() => {
        //关闭过渡页面
        loadingCarViewVisible.value = false
        //重新顯示下方的操作欄
        bottomInteractionUiVisible.value = true
        //重新顯示右上角的操作欄
        upperRightUiVisible.value = true
        //重新顯示搖桿
        nippleViewVisible.value = true
        //允许操作
        controlFlag = true
    }, 5500)
}

//加载glb模型
function loadGlbModel(modelName, option = {}) {
    let deleteFlag = true

    if (glbLoadFlag){
        glbLoadQueue.push(() => {
            loadGlbModel(modelName, option)
        })
        return
    }else{
        if (glbLoadQueue.length == 0){
            deleteFlag = false
        }

        glbLoadFlag = true
    }

    let optionObj = {
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        scaleY: 0,
        rotateX: 0,
        rotateY: 0,
        rotateZ: 0,
        castShadow: false,
        receiveShadow: false,
        //加载模型成功后的回调
        loadCallback: null,
        //执行结束后的回调
        callback: null,
        //是否缓存加载的模型
        cache: true
    }

    optionObj = Object.assign(optionObj, option);

    const ObjGroup = new THREE.Group()

    //如果在缓存中没有该模型,加载模型
    if (null == loadObj[modelName]){
        //同步加载，避免出现同时加载多个时null
        const promiseHander = new Promise((resolve, reject) =>{
            gltfLoader.load( process.env.BASE_URL + `mymodels/gltf/${modelName}?r=${proxy.$versionNum}`, function ( gltf ) {

                if (optionObj.cache){
                    loadObj[modelName] = gltf
                    // model = model.clone()
                    loadObj[modelName].scenes = []
                    const modelData = loadObj[modelName].scene
                    loadObj[modelName].scene = null

                    const copyObj = Object.assign({}, loadObj[modelName])
                    copyObj.scene = clone(modelData)
                    loadObj[modelName].scene = modelData

                    gltf = copyObj
                }

                let model = gltf.scene;

                optionObj["format"] = "gltf"

                handleModel(model, optionObj)

                ObjGroup.add(model)

                if (typeof optionObj.loadCallback === "function"){
                    optionObj.loadCallback(gltf, model)
                }

                ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

                if (typeof optionObj.callback === "function"){
                    optionObj.callback(ObjGroup)
                }

                if (deleteFlag){
                    glbLoadQueue.splice(0, 1)
                }

                glbLoadFlag = false
                if (glbLoadQueue.length > 0){
                    glbLoadQueue[0]()
                }

                return ObjGroup

                resolve()
            })
        })

    }else{
        //如果缓存中有此模型，克隆该模型
        const modelData = loadObj[modelName].scene
        loadObj[modelName].scene = null
        const copyObj = Object.assign({}, loadObj[modelName])
        copyObj.scene = clone(modelData)
        loadObj[modelName].scene = modelData

        let gltf = copyObj
        let model = gltf.scene

        handleModel(model, optionObj)

        ObjGroup.add(model)

        if (typeof optionObj.loadCallback === "function"){
            optionObj.loadCallback(gltf, model)
        }

        ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

        if (typeof optionObj.callback === "function"){
            optionObj.callback(ObjGroup)
        }

        if (deleteFlag){
            glbLoadQueue.splice(0, 1)
        }
        glbLoadFlag = false
        if (glbLoadQueue.length > 0){
            glbLoadQueue[0]()
        }

        return ObjGroup
    }
}

//根据传入的参数调整模型
function handleModel(model, optionObj) {
    let box3 = new THREE.Box3()
    let obj = new THREE.Vector3()
    let scaleNum
    box3.setFromObject(model)
    box3.getSize(obj)

    // if (optionObj.castShadow || optionObj.receiveShadow){
    model.traverse( function ( object ) {
        if ( object.isMesh ) {
            // if (optionObj.castShadow ){
            object.castShadow = true;
            // }

            // if (optionObj.receiveShadow ){
            object.receiveShadow = true;
            // }

            if (optionObj.format === "fbx"){
                object.material.emissive = new THREE.Color(1,1,1);
                object.material.emissiveIntensity = 1;
                object.material.emissiveMap = object.material.map;
            }

        }
    } );
    // }

    if (optionObj.rotateX > 0){
        model.rotation.x = optionObj.rotateX
    }

    if (optionObj.rotateY > 0){
        model.rotation.y = optionObj.rotateY
    }

    if (optionObj.rotateZ > 0){
        model.rotation.z = optionObj.rotateZ
    }

    if (optionObj.scaleY > 0){
        scaleNum = optionObj.scaleY / obj.getComponent(1)
        let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
        model.scale.multiply(vector);
    }


    return model
}

function loadMaterialImg(){
    let startIndex = (regionMap.currPage - 1) * 20

    if (startIndex < materialList.value.length){
        for (let i=0; i<20; i++){
            const groupIndex = i + 1
            const materialIndex = startIndex + i
            const group = materialPositionMap[groupIndex]
            const nameGroup = materialNameMap[groupIndex]
            const vec3 = new THREE.Vector3()
            const material = group.material

            group.getWorldPosition(vec3)

            if (null != material){
                group.material = null
                group.visible = false
                material.dispose()
            }

            if (materialIndex < materialList.value.length){
                const item = materialList.value[materialIndex]
                let imgUrl = myUtil.generateProductImg(item)

                try {
                    texLoader.load(imgUrl, (texture) => {
                        texture.colorSpace = THREE.SRGBColorSpace
                        texture.flipY = false
                        const newMaterial = new THREE.MeshBasicMaterial({
                            side: THREE.DoubleSide,
                            map: texture
                        })

                        group.material = newMaterial
                        group.visible = true
                    },
                    () => {},
                    () => {
                        loadDefaultImg(group)
                    })
                }catch (e){
                    console.log(e)
                }

                let productname = item.productnamecn
                let productid = item.id

                if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh" || myUtil.isEmpty(productname)){
                    productname = item.productname
                }

                nameGroup.material = createProductnamePad(productname)

                triggerAreaMap[group.uuid] = {
                    scope: {
                        MAX_POSITION_X: vec3.x + 2.5,
                        MIN_POSITION_X: vec3.x - 2.5,
                        MAX_POSITION_Z: vec3.z + 2.5,
                        MIN_POSITION_Z: vec3.z - 2.5,
                    },
                    alive: false,
                    timer: 0.5,
                    timeLimit: 0.5,
                    func: () => {
                        // meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                        currMaterial.value = item
                        materialViewVisible.value = true

                    },
                    leaveCallback: () => {
                        closeDialogCallback()
                    }
                }

                clearDataList.push({"key": group.uuid, map: triggerAreaMap})

                const key = `rotate_${group.uuid}`
                const withAIObj = {
                    model: group,
                    positionY: group.position.y,
                    rotationY: 0,
                    offset: 0.0005,
                    rotationOffset: 0.0005,
                    sum: 0,
                    AI: (obj) => {
                        if (obj.sum > 0.06){
                            obj.offset = -0.0005
                        }

                        if (obj.sum <= -0.06){
                            obj.offset = 0.0005
                        }

                        obj.sum += obj.offset
                        obj.model.position.y = obj.positionY + obj.sum

                        if (obj.rotationY > Math.PI / 180 * 6){
                            obj.rotationOffset = -0.0005
                        }

                        if (obj.rotationY <= Math.PI / 180 * -6){
                            obj.rotationOffset = 0.0005
                        }

                        obj.rotationY += obj.rotationOffset
                        obj.model.rotation.y = obj.rotationY
                    }
                }
                WithAIObjSet[key] = withAIObj

                clearDataList.push({"key": key, map: WithAIObjSet})

                // interactionObj[group.uuid] = [{
                //     distance: 6,
                //     icon: "fa-solid fa-comments",
                //     name: i18n.tkey("lang_communicate"),
                //     description: productname,
                //     mesh: group,
                //     callback: () => {
                //         const url = myUtil.generateProductInfoUrl(productid)
                //         clickGoMaterialChat(hallObjInfo.businessLogin, url)
                //     }
                // }]
                //
                // clearDataList.push({"key": group.uuid, map: WithAIObjSet})

            }

        }
    }else{
        for (let i=0; i<20; i++) {
            const groupIndex = i + 1
            const group = materialPositionMap[groupIndex]
            const material = group.material

            if (null != material) {
                group.material = null
                group.visible = false
                material.dispose()
            }
        }
    }

}

//將主角傳送到某個店鋪門口
function movePersonToShopPosition(doorNum) {
    let index = Number(doorNum) > 9 ? doorNum : "0" + doorNum

    const obj = shopPointMap[index].positionObj

    const shopPosition = new THREE.Vector3()

    obj.getWorldPosition(shopPosition)
    shopPosition.x = myUtil.toDecimal2(shopPosition.x)
    shopPosition.z = myUtil.toDecimal2(shopPosition.z)

    obj.traverse((child) => {
        let transferName = `shoptransfer_${index}`

        if (child.name === transferName){
            const worldPosition = new THREE.Vector3()
            child.getWorldPosition(worldPosition)
            worldPosition.x = myUtil.toDecimal2(worldPosition.x)
            worldPosition.z = myUtil.toDecimal2(worldPosition.z)
            meshGroup.position.copy(worldPosition)

            const cameraDirect = new THREE.Vector3()
            cameraDirect.x = worldPosition.x - shopPosition.x
            cameraDirect.z = worldPosition.z - shopPosition.z
            cameraDirect.normalize()

            if (Math.abs(cameraDirect.x) > Math.abs(cameraDirect.z)){
                camera.position.z = 0

                if (cameraDirect.x > 0){
                    camera.position.x = cameraOptionObj.currCameraDistance
                }else{
                    camera.position.x = cameraOptionObj.currCameraDistance * -1
                }
            }else{
                camera.position.x = 0

                if (cameraDirect.z > 0){
                    camera.position.z = cameraOptionObj.currCameraDistance
                }else{
                    camera.position.z = cameraOptionObj.currCameraDistance * -1
                }
            }

            camera.position.y = cameraOptionObj.currCameraPositionY
            camera.lookAt(new THREE.Vector3(meshGroup.position.x,1.6,meshGroup.position.z));
            testBox.lookAt(shopPosition)

            if (cameraDirect.x > 0 && cameraDirect.z == 0){
                rotationNum = 0
            }else{
                rotationNum = cameraDirect.x * Math.PI + cameraDirect.z * Math.PI / 2
            }

        }
    })

}

function disposeMesh(mesh) {
    try {
        mesh.parent.remove(mesh)

        mesh.traverse((child) => {
            if (child.material) {
                child.material.dispose();
            }
            if (child.geometry) {
                child.geometry.dispose();
            }
            child = null;
        })
    }catch (e) {
        // console.log(e)
    }
}

function disposeData(data) {
    try {
        data.map[data.key] = null
        delete data.map[data.key]
    }catch (e) {
        console.log(e)
    }
}

function clearSenceData() {
    clearDataList.forEach((v, i) => {
        disposeData(v)
    })

    clearMeshList.forEach((v, i) => {
        disposeMesh(v)
    })

    clearAIList.forEach((v, i) => {
        disabledAIObj(v)
    })

    clearDataList = []
    clearMeshList = []
    clearAIList = []
}

function disabledAIObj(obj){
    obj.AI = null
}

function closeDialogCallback(){
    materialViewVisible.value = false
    currMaterial.value = null
}

function clickSearchInput() {
    searchPEMaterialVisible.value = true
    // proxy.$refs.shopopeePhone.goSearchView()
}

function goChatView() {
    proxy.$refs.shopopeePhone.goChatView()
}

function goLogin() {
    proxy.$refs.shopopeePhone.goLoginView()
}

function goAccountView() {
    // proxy.$refs.shopopeePhone.goMyCardView()
    proxy.$refs.shopopeePhone.goDisplayIndexView()
}

function clickGoMaterialChat(login, productid){
    proxy.$refs.shopopeePhone.goMaterialChat(login, productid)
}

function phoneCommandCallback(functionName, status, data){
    // if (functionName === "openPersonChat" || functionName === "goCardView"){
    shopopeeChatVisible.value = true
    bottomInteractionUiVisible.value = false
    upperRightUiVisible.value = false
    nippleViewVisible.value = false
    controlFlag = false
    setTimeout(() => {
        shopopeeChatStatus.value = "show"
    }, 25)
    // }
}

function loginCallback(){

}

function hideShopopeeChatBox() {
    if (shopopeeChatStatus.value === "hide"){
        return
    }

    shopopeeChatStatus.value = "hide"

    // setTimeout(() => {
    shopopeeChatVisible.value = false
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true
    nippleViewVisible.value = true
    controlFlag = true
    // }, 1450)
}

function goShopPosition(wa, siojournal) {

}

function goThreeGuide() {

}

function clickAudio(){

}

function clickReturnShopopee() {
    hideShopopeeChatBox()

    setTimeout(() => {
        confirmReturnShopopee()
    }, 250)
}

function confirmReturnShopopee() {
    openConfirm(i18n.tkey("lang_return_shopopee_confirm"), () => {
        window.location.href = `${proxy.$ShopopeeUrl}my_memberwork`
    })
}

function openConfirm(text, func, func2){
    moveFlag = false
    speed = 0
    confirmVisible.value = true
    confirmFunc = func
    cancelFunc = func2
    controlFlag = false
    nippleViewVisible.value = false
    setTimeout(() => {
        confirmText.value = text
    }, 1250)
}

function sureConfirm() {
    if (typeof confirmFunc === "function"){
        confirmFunc()
    }

    confirmVisible.value = false
    confirmText.value = ""
    confirmFunc = null
    cancelFunc = null
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true

    controlFlag = true

    setTimeout(() => {
        nippleViewVisible.value = true
    }, 250)
}

function closeConfirm() {
    if (typeof cancelFunc === "function"){
        cancelFunc()
    }

    confirmVisible.value = false
    confirmText.value = ""
    confirmFunc = null
    cancelFunc = null
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true

    controlFlag = true

    setTimeout(() => {
        nippleViewVisible.value = true
    }, 250)
}

function clickReturnIcon(){
    toggleSelectFloorBox(true)
}

function clickReturn3DCityBtn(){
    toggleSelectFloorBox(false)
    // selectFloorVisible.value = false

    openConfirm(i18n.tkey("lang_return_3dShop_confirm_1"), () => {
        pageInfoRef.value.userFrom = 0
        pageInfoRef.value.rotationNum = Math.PI / 2

        if (null == pageInfoRef.value.hid){
            if (null == userInfoRef.value.islandID){
                proxy.$router.push({
                    name: "demoIndex2"
                })
            }else{
                proxy.$router.push({
                    path: `/${userInfoRef.value.islandID}/index`
                })
            }
        }else{
            proxy.$router.push({
                path: `/hall/${pageInfoRef.value.hid}`
            })
        }

    })
}

function goSelectFloor(num, dnum){
    if (null != num){
        selectFloorNum.value = num
    }

    if (num == regionMap.currPage && myUtil.isEmpty(dnum)){
        closeSelectFloor()
        return
    }

    regionMap.currPage = selectFloorNum.value
    regionMap.selectShopIndex = dnum
    toggleSelectFloorBox(false)
    goNextRegion()
    regionMap.selectShopIndex = null
}

function closeSelectFloor(){
    toggleSelectFloorBox(false)
}

//顯示或者關閉樓層選擇窗口
function toggleSelectFloorBox(flag = true) {
    if (flag === true){
        moveFlag = false
        speed = 0
        selectFloorNum.value = regionMap.currPage
        selectFloorVisible.value = true
        controlFlag = false
    }else{
        selectFloorNum.value = regionMap.currPage
        selectFloorVisible.value = false
        controlFlag = true
    }

}

function goMaterialPosition(fid, did){
    searchPEMaterialVisible.value = false
    regionMap.currPage = fid
    regionMap.selectShopIndex = did

    goNextRegion()
}

function createFloorNamePad(){
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 150
    canvas.height = 100
    //制作矩形
    ctx.fillStyle = "transparent";
    ctx.fillRect(0, 0, 150, 100)
    //设置文字
    ctx.fillStyle = "#ff0000";
    ctx.font = 'normal 100px "楷体"'
    ctx.fillText(regionMap.currPage + "F", 10, 80)

    //生成图片
    let url = canvas.toDataURL('image/png');
    //删除dom
    canvas.remove()
    //将图片构建到纹理中
    const orgMaterial = hallFloorPadMesh.material
    const map = texLoader.load(url)

    map.flipY = false

    hallFloorPadMesh.material = new THREE.MeshBasicMaterial({
        map: map,
        side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    try {
        orgMaterial.dispose()
    }catch (e) {

    }
}

function getMaterialListData(){
    return materialList.value
}

function loadDefaultImg(group){
    const url = `${publicPath}mytextures/404_img.png`

    try {
        texLoader.load(url, (texture) => {
            texture.colorSpace = THREE.SRGBColorSpace
            texture.flipY = false
            const newMaterial = new THREE.MeshBasicMaterial({
                side: THREE.DoubleSide,
                map: texture
            })

            group.material = newMaterial
            group.visible = true
        })
    }catch (e){
        group.material = null
        group.visible = false
    }

}

function getHallData(){
    const request = companyApi.getCompanyHallInfo
    const params = request.getParams()

    params.id = props.rid

    request.send(params, (res) => {
        if (res.code == 200){
            // res.detail.materialList = res.detail.materialList.concat(res.detail.materialList)
            // res.detail.materialList = res.detail.materialList.concat(res.detail.materialList)
            // res.detail.materialList = res.detail.materialList.concat(res.detail.materialList)
            // res.detail.materialList = res.detail.materialList.concat(res.detail.materialList)
            // res.detail.materialList = res.detail.materialList.concat(res.detail.materialList)
            // res.detail.materialList = res.detail.materialList.concat(res.detail.materialList)

            hallObjInfo = res.detail
            const list = res.detail.materialList
            list.forEach((v, i) => {
                const pageIndex = parseInt(i / 20) + 1
                const doorNum = i % 20 + 1

                if (null == materialMap[pageIndex]){
                    materialMap[pageIndex] = {}
                }

                materialMap[pageIndex][doorNum] = v
                v.wa = pageIndex
                v.siojournal = doorNum

            })

            materialList.value = res.detail.materialList

            if (materialList.value.length > 0){
                lastPageNum.value = parseInt(materialList.value.length / 20) + 1
            }else{
                lastPageNum.value = 1
            }

            initValue()
        }else{
            myUtil.alertError(res.msg)
        }
    })
}

function createHallAirWall(){
    return

    const minX = -6.5
    const maxX = 0.5
    const minZ = -0.55
    const maxZ = 0.55

    airWallList["right_wall_0"] = {
        MAX_POSITION_X: maxX,
        MIN_POSITION_X: minX,
        MAX_POSITION_Z: maxZ,
        MIN_POSITION_Z: minZ
    }

    for (let i = 1; i < 46; i++){
        const XNum = i * 0.17
        const ZNum = i

        airWallList[`right_wall_${i}`] = {
            MAX_POSITION_X: maxX - XNum,
            MIN_POSITION_X: minX - XNum,
            MAX_POSITION_Z: maxZ + ZNum,
            MIN_POSITION_Z: minZ + ZNum
        }

        // let boxGeometry = new THREE.BoxGeometry(6, 6, 1)
        // let lambertMaterial = new THREE.MeshBasicMaterial({
        //     color: 0xff0000
        // })
        //
        // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
        // scene.add(mesh)
        // mesh.position.x = (maxX - XNum) + (minX - XNum) / 2
        // mesh.position.z = (maxZ + ZNum) + (minZ + ZNum) / 2
        // console.log(mesh.position.z)

        airWallList[`right_wall_-${i}`] = {
            MAX_POSITION_X: maxX - XNum,
            MIN_POSITION_X: minX - XNum,
            MAX_POSITION_Z: maxZ - ZNum,
            MIN_POSITION_Z: minZ - ZNum
        }
    }
}

function getEmptyWithAIObj() {
    const withAIObj = {
        group: null,
        model: null,
        allActions: null,
        activeAction: null,
        previousAction: null,
        nextTargetPosition: null,    //Vector3
        previousTargetPosition: null,
        targetPositionList: [],
        AI: null,
        action: null,
        name: "",
        memMale: 0,
        targetIndex: 0,
        timer_1: 0,
        timer_2: 0
    }

    return withAIObj
}

function createHost(positionGroup){
    const vec3 = new THREE.Vector3();
    positionGroup.getWorldPosition(vec3)

    const withAIObj = getEmptyWithAIObj()

    positionGroup.rotation.y = Math.PI / -2

    withAIObj.login = ""
    withAIObj.name = ""
    withAIObj.memMale = ""
    withAIObj.whatsshopsbcataList = ""
    withAIObj.companyName = ""

    loadGlbModel("town2/aman.gltf",{
        loadCallback: (gltf,model) => {
            withAIObj.model = model

            const mixer = new THREE.AnimationMixer( model );
            mixerObj[model.uuid] = mixer

            withAIObj.allActions = {};

            let animations = gltf.animations;

            for ( let i = 0; i !== animations.length; ++ i ) {
                //動作
                const clip = animations[ i ];
                const action = mixer.clipAction( clip );
                withAIObj.allActions[clip.name ] = action;

            }

            withAIObj.activeAction = withAIObj.allActions['waving'];
            withAIObj.activeAction.play();

            withAIObj.action = 'waving'

            model.traverse( function ( object ) {
                if ( object.isMesh ) {
                    object.material.emissive = null;
                    object.material.emissiveIntensity = 0;
                    object.material.emissiveMap = null;
                }
            });

        },
        callback: (group) => {
            WithAIObjSet[group.uuid] = withAIObj
            withAIObj.group = group

            // 加载店员的ai
            withAIObj.AI = ShopmanAI

            positionGroup.add(group)

        }
    })
}

function toggleActiveMotionObj(obj, name) {
    obj.activeAction.paused = true
    obj.previousAction = obj.activeAction
    obj.activeAction = obj.allActions[name];
    obj.activeAction.reset().play();

    obj.previousAction.crossFadeTo( obj.activeAction, 0.25 )
}

//店员的ai
function ShopmanAI(withAIObj) {
    const vec3 = new THREE.Vector3()

    withAIObj.group.getWorldPosition(vec3)

    // const distance = meshGroup.position.distanceTo(withAIObj.group.position)
    const distance = meshGroup.position.distanceTo(vec3)

    withAIObj.timer_1 += mixerUpdateDelta

    if (distance < 6 ){

        if (null != animationObjGroup[withAIObj.group.uuid]){
            animationObjGroup[withAIObj.group.uuid].pause()
        }

        if (withAIObj.action === 'idle' || withAIObj.action === 'walk_normal'){
            if (withAIObj.action !== 'waving'){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if (withAIObj.action === 'idle_wait'){
            if (withAIObj.timer_1 > 6){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'deliver_card_wait'){
            withAIObj.action = 'deliver_card'
            withAIObj.timer_1 = 0
            toggleActiveMotionObj(withAIObj, "talk2")
        }else if(withAIObj.action === 'deliver_card'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'chat_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'chat_wait'){
            if (withAIObj.timer_1 > 4){
                withAIObj.action = 'chatting'
                withAIObj.timer_1 = 0

                const randomNum = Math.random()

                if (randomNum < 0.5){
                    toggleActiveMotionObj(withAIObj, "talk")
                }else{
                    toggleActiveMotionObj(withAIObj, "clapping")
                }

            }
        }else if(withAIObj.action === 'chatting'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'chat_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'chat_complete'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }


        withAIObj.model.lookAt(meshGroup.position)
    }else{
        if (withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }

        // if (withAIObj.action === 'idle_wait'){
        //     if (withAIObj.timer_1 > 1.5){
        //
        //         withAIObj.action = 'walk_normal'
        //         withAIObj.timer_1 = 0
        //         toggleActiveMotionObj(withAIObj, "walk")
        //
        //         if (null != animationObjGroup[withAIObj.group.uuid]){
        //
        //             if (animationObjGroup[withAIObj.group.uuid]._isPaused){
        //                 animationObjGroup[withAIObj.group.uuid].resume()
        //
        //                 withAIObj.model.lookAt(withAIObj.nextTargetPosition)
        //             }
        //
        //         }
        //     }
        // }
    }

}

function createProductnamePad(text) {
    let fontsize = 1160 / text.length
    let xLeft

    if (fontsize > 130){
        fontsize = 130
    }

    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 1200
    canvas.height = 200
    //制作矩形
    ctx.fillStyle = "transparent";
    // ctx.fillStyle = "#0000ff";
    // ctx.drawImage(shopSignTexture, 0, 0, 1200, 200)
    ctx.fillRect(0, 0, 1200, 200)
    //设置文字
    // ctx.fillStyle = "#ffffff";
    ctx.fillStyle = "#000000";
    ctx.font = `normal ${fontsize}px "楷体"`
    const textWidth = ctx.measureText(text).width;
    xLeft = 20 + (1160 - textWidth) / 2
    ctx.fillText(text, xLeft, 100 + fontsize / 2)

    // console.log(fontsize)

    //生成图片
    let url = canvas.toDataURL('image/png');

    let map = texLoader.load(url)
    map.flipY = false

    const material = new THREE.MeshBasicMaterial({
        map: map,
        side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    canvas.remove()

    return material
}

function clickInteractionCallback(value){
    if(null != value && null != value.callback && typeof value.callback === "function"){
        value.callback()
    }
}

function clickMaterialChatCallback(obj){
    materialViewVisible.value = false
    const url = myUtil.generateProductInfoUrl(obj.id)
    clickGoMaterialChat(hallObjInfo.businessLogin, url)
}

provide('threePEFunc', {
    goMaterialPosition,
    getMaterialListData
})

onBeforeMount(() => {
    styleObj.value = {
        width: `${pageWidth}px`,
        height: `${pageHeight}px`
    }
})

onMounted(() => {
    if (null != props.rid){
        shopCompanyCode.value = props.rid
        getHallData()
    }
})

//清除three.js占用的内存
onBeforeUnmount(() => {
    //保存主角位置
    // savePersonPosition()

    //銷毀搖桿
    if (null != nippleObj){
        nippleObj.destroy()
    }

    console.log("开始清除内存")

    document.getElementById("three").removeEventListener('touchmove', handleDefaultTouchEvt)
    document.removeEventListener('keydown', onKeyDown)
    document.removeEventListener('keyup', onKeyUp)
    document.getElementById("three").removeEventListener('touchmove', mouseMoveEvent)
    document.getElementById("three").removeEventListener('touchstart', mouseDownEvent)
    document.getElementById("three").removeEventListener('touchend', mouseUpEvent)
    document.getElementById("three").removeEventListener('mousemove', mouseMoveEvent)
    document.getElementById("three").removeEventListener('mousedown', mouseDownEvent)
    document.getElementById("three").removeEventListener('mouseup', mouseUpEvent)
    document.getElementById("three").removeEventListener('click', mouseClickEvent)

    // stats.domElement.remove()

    try {
        funcListObj = {}

        cancelAnimationFrame(animationFrameId); // animationFrameId = requestAnimationFrame(this.render);
        render.dispose();
        render.forceContextLoss();
        render.content = null;
        let gl = render.domElement.getContext("webgl");
        if (gl && gl.getExtension("WEBGL_lose_context")) {
            gl.getExtension("WEBGL_lose_context").loseContext();
        }
        render = null;
        camera = null;
        scene.traverse((child) => {
            try {
                if (child.material && null != child.material) {
                    child.material.dispose();
                }
            }catch (e) {
                console.log(e)
            }

            try {
                if (child.geometry && null != child.geometry) {
                    child.geometry.dispose();
                }
            }catch (e) {
                console.log(e)
            }


            child = null;
        });
        scene = null;

        THREE.Cache.clear()
    } catch (e) {
        console.error('Failed to destroy threejs', e);
    }

    //刪除render dom
    document.getElementById("three").innerHTML = ""
})

</script>

<style scoped>

.page-view {
    position: relative;
    width: 100%;
    height: 100%;
}

.shopopee-chat-view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 1.5s ease;
    overflow: hidden;
    z-index: 301;
}

@media screen and (min-width: 520px) {
    .shopopee-chat-view .close-div {
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
        color: #333;
        position: absolute;
        /*left: 50%;*/
        top: 0;
        right: 0;
        /*margin-top: -400px;*/
        /*margin-left: 275px;*/
        border-radius: 50%;
        width: 50px;
        height: 50px;
        text-shadow: 0 1px 0 #484f58;
        //border: 1px solid #734e4e;
        //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
        //background: -webkit-linear-gradient(top, #e92323, #551d1d);
        /*transition: all 1.5s ease;*/
        z-index: 100;
    }
}

@media screen and (max-width: 520px) {
    .shopopee-chat-view .close-div {
        display: inline-block;
        font-size: 30px;
        line-height: 40px;
        color: #333;
        position: absolute;
        right: 3px;
        top: 3px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        text-shadow: 0 1px 0 #484f58;
        //border: 1px solid #734e4e;
        //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
        //background: -webkit-linear-gradient(top, #e92323, #551d1d);
        /*transition: all 1.5s ease;*/
        z-index: 100;
    }
}

.shopopee-chat-view .close-div-hide {
    opacity: 0;
    transform: scale(0.5);
    animation: hide-shopopee-chat-close-div 0.5s ease;
}

@keyframes hide-shopopee-chat-close-div {

    0% {
        opacity: 1;
        transform: scale(1);
    }

    100% {
        opacity: 0;
        transform: scale(0.5);
    }

}

.shopopee-chat-view .close-div-show {
    opacity: 1;
    transform: scale(1);
    animation: show-shopopee-chat-close-div 0.5s ease;
}

@keyframes show-shopopee-chat-close-div {

    0% {
        opacity: 0;
        transform: scale(0.5);
    }

    75% {
        opacity: 0;
        transform: scale(0.5);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }

}

.shopopee-chat-view-extend {
    background: #00000050;
}

.shopopee-chat-view-retract {
    background: #ffffff00;
}

.my-dialog {
    position: relative;
    top: -30px;
}

</style>